module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2",
    attrs: {
      "id": "contents"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/Text/preface#preface"
    }
  }, [_vm._v("Preface")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/Text/ack#ack"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-part"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/Text/part01#part01"
    }
  }, [_vm._v("PART 1: THE PROBLEM")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/Text/ch01#ch01"
    }
  }, [_c('em', [_vm._v("Chapter 1")]), _vm._v(" Time to Upgrade")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/Text/ch02#ch02",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Chapter 2")]), _vm._v(" A Short History of Capitalism")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/Text/ch03#ch03",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Chapter 3")]), _vm._v(" The Limits of Government")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/Text/ch04#ch04",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Chapter 4")]), _vm._v(" The Limits of Privatization")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-part"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/Text/part02#part02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PART 2: A SOLUTION")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/Text/ch05#ch05",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Chapter 5")]), _vm._v(" Reinventing the Commons")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/Text/ch06#ch06",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Chapter 6")]), _vm._v(" Trusteeship of Creation")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/Text/ch07#ch07",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Chapter 7")]), _vm._v(" Universal Birthrights")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/Text/ch08#ch08",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Chapter 8")]), _vm._v(" Sharing Culture")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-part"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/Text/part03#part03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PART 3: MAKING IT HAPPEN")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/Text/ch09#ch09",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Chapter 9")]), _vm._v(" Building the Commons Sector")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/Text/ch10#ch10",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Chapter 10")]), _vm._v(" What You Can Do")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/Text/appendix#appendix",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendix")])]), _vm._v(" "), _c('p', {
    staticClass: "tocbm"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/Text/notes#notes",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Notes")])]), _vm._v(" "), _c('p', {
    staticClass: "tocbm"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/Text/resource#resource",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Web Resource Guide")])]), _vm._v(" "), _c('p', {
    staticClass: "tocbm"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/Text/bib#bib",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bibliography")])]), _vm._v(" "), _c('p', {
    staticClass: "tocbm"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/Text/index#index",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Index")])]), _vm._v(" "), _c('p', {
    staticClass: "tocbm"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/Text/about#about",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Author")])]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_c('a', {
    attrs: {
      "id": "page_viii"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-78ee341a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/contents.vue
// module id = 75
// module chunks = 0